var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticStyle:{"background-color":"#4BA9F6","color":"white","border-radius":"10px"}},[_vm._v(_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }